<template>
  <atm-sidebar
    :show="showSidebar"
    :title="$t('Carrinho')"
    width="700px"
    :no-close-on-backdrop="false"
    @hidden="onHide"
  >
    <template #content>
      <div class="cart-container">
        <b-row class="cart-itens-container position-relative">
          <template v-if="getItems.length > 0">

            <!-- Seção de uso do saldo ecash -->
            <b-col
              v-if="hasCustomerIdentified && hasRewardBalance"
              md="12"
              class="ecash-section mt-1 mb-1"
            >
              <div class="ecash-card p-1">
                <div class="d-flex align-items-center justify-content-center mb-2">
                  <div class="d-flex align-items-center">
                    <img
                      :src="ecashLogo"
                      alt="ecash"
                      class="ecash-logo-header mr-1"
                      style="display: block"
                    >
                    <div
                      style="display: block"
                      class="mb-0 h4 text-success font-weight-bold"
                    >
                      Temos desconto para você!
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-center mb-2">
                  <div class="d-flex align-items-center">
                    <img
                      :src="ecashMoeda"
                      alt="ecash"
                      class="ecash-logo"
                    >
                    <div class="ml-1">
                      <p class="mb-0 font-weight-bold text-dark">
                        Saldo ecash:&nbsp;<span class="mb-0 h4 text-success font-weight-bold">{{
                          formatRewardBalance(rewardBalance)
                        }}</span>
                      </p>
                    </div>
                  </div>
                </div>

                <div v-if="!hasRewardsApplied">
                  <e-button
                    variant="success"
                    class="w-100 atm-btn"
                    text="Usar saldo ecash"
                    icon="cash-coin"
                    :busy="ecashLoading"
                    @click="onApplyRewards"
                  />
                </div>
                <div v-else>
                  <div class="mb-2 p-2 bg-light rounded">
                    <p class="mb-0 text-success font-weight-bold">
                      ✓ Saldo ecash aplicado: {{ getRewardsAmountUsed | currency }}
                    </p>
                  </div>
                  <e-button
                    variant="outline-danger"
                    class="w-100 atm-btn"
                    text="Remover desconto ecash"
                    icon="x-circle"
                    @click="onRemoveRewards"
                  />
                </div>
              </div>
            </b-col>

            <b-col md="12">
              <atm-reward-banner />
            </b-col>

            <b-col md="12">
              <atm-cart-item-list
                :cart-item-list="getItems"
                :busy="addItemLoading"
                @add-suggestion="onAddSuggestion"
              />
            </b-col>

            <!-- Seção de sugestões de compra -->
            <atm-cart-suggestions
              :cart-items="getItems"
              :sidebar-open="showSidebar"
              :busy="addItemLoading"
              orientation="horizontal"
              @add-suggestion="onAddSuggestion"
            />

            <b-col
              md="12"
              class="position-sticky"
              style="bottom: 0"
            >
              <div class="mt-1 bg-white py-2 px-3 rounded">
                <div class="d-flex justify-content-between mb-1">
                  <p class="h5 mb-0 text-muted">
                    Subtotal:
                  </p>
                  <p class="h5 mb-0 text-muted">
                    {{ getSubtotalSale | currency }}
                  </p>
                </div>
                <div
                  v-if="hasRewardsApplied"
                  class="d-flex justify-content-between mb-1"
                >
                  <p class="h5 mb-0 text-success">
                    Desconto ecash:
                  </p>
                  <p class="h5 mb-0 text-success">
                    -{{ getRewardsAmountUsed | currency }}
                  </p>
                </div>
                <div class="d-flex justify-content-between border-top pt-2">
                  <p class="h3 mb-0 font-weight-bold">
                    Total:
                  </p>
                  <p class="h3 mb-0 font-weight-bold">
                    {{ getTotalSale | currency }}
                  </p>
                </div>
              </div>
            </b-col>
          </template>
          <b-col
            v-else
            md="12"
            class="d-flex justify-content-center align-items-center"
          >
            <p>Nenhum produto adicionado</p>
          </b-col>
        </b-row>
      </div>
    </template>

    <template #sidebar-footer>
      <div class="cart-footer h-100">
        <e-button
          variant="secondary"
          class="atm-btn"
          :text="$t('Continuar compra')"
          @click="() => onHide()"
        />

        <e-button
          :busy="paymentLoading || hasPendingActions"
          variant="primary"
          class="atm-btn"
          :text="$t('Pagamento')"
          @click="() => onPayment()"
        />
      </div>
      <reward-terms-modal
        ref="rewardTermsModal"
        @accept="onTermsAccepted"
        @reject="onTermsRejected"
      />
      <reward-code-verification-modal
        ref="codeVerificationModal"
        @verified="onCodeVerified"
        @cancelled="onCodeVerificationCancelled"
        @close="ecashLoading = false"
      />
    </template>
  </atm-sidebar>
</template>

<script>
import { BCol, BRow } from 'bootstrap-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { atmScreenEnum } from '@/store/pages/pdv/atm'
import { alerts } from '@/mixins'
import EButton from '@/views/components/EButton.vue'
import ecashLogo from '@/assets/images/logo/ecash_logo.png'
import ecashMoeda from '@/assets/images/logo/ecash_moeda.png'
import axiosInstance from '@/libs/axios'
import AtmCartItemList from './lists/AtmCartItemList.vue'
import AtmSidebar from './sidebar/AtmSidebar.vue'
import RewardTermsModal from './modals/RewardTermsModal.vue'
import RewardCodeVerificationModal from './modals/RewardCodeVerificationModal.vue'
import AtmCartSuggestions from './AtmCartSuggestions.vue'
import AtmRewardBanner from './cards/AtmRewardBanner.vue'

export default {
  components: {
    EButton,
    BCol,
    BRow,
    AtmSidebar,
    AtmCartItemList,
    RewardTermsModal,
    RewardCodeVerificationModal,
    AtmCartSuggestions,
    AtmRewardBanner,
  },

  mixins: [alerts],

  props: {},

  data: () => ({
    showSidebar: false,
    paymentLoading: false,
    ecashLoading: false,
    addItemLoading: false,
    ecashLogo,
    ecashMoeda,
  }),

  computed: {
    ...mapGetters('pages/pdv/atm/status', ['getIsCartOpen', 'hasPendingActions']),

    ...mapGetters('pages/pdv/payBox', [
      'getItems',
      'getTotalSale',
      'getSubtotalSale',
      'hasRewardsApplied',
      'getRewardsAmountUsed',
      'getCustomerDocument',
      'salePriceTableId',
    ]),

    ...mapState('pages/pdv/payBox', {
      clientForm: 'clientForm',
    }),

    ...mapState('reward', {
      rewardBalance: 'rewardBalance',
    }),

    ...mapGetters('reward', ['hasRewardBalance', 'formatRewardBalance', 'rewardConfiguration']),

    hasCustomerIdentified() {
      return this.getCustomerDocument && this.getCustomerDocument.trim() !== ''
    },

    resumeData() {
      return {
        total: this.getTotalSale,
      }
    },
  },

  watch: {
    getIsCartOpen(val) {
      if (val) {
        this.showSidebar = true
      } else {
        this.showSidebar = false
      }
    },
  },

  unmounted() {
    this.stSetIsCartOpen(false)
  },

  methods: {
    ...mapActions('pages/pdv/atm/status', {
      stSetAtmScreen: 'setAtmScreen',
      stSetIsCartOpen: 'setIsCartOpen',
    }),

    ...mapActions('pages/pdv/atm', {
      stValidateCartItems: 'validateCartItems',
      stAddItemFromAtm: 'addItemFromAtm',
    }),

    ...mapActions('pages/pdv/payBox', {
      stApplyRewards: 'applyRewards',
      stSetRewardProgramOptedIn: 'setRewardProgramOptedIn',
    }),

    ...mapActions('reward', {
      stCalculateRewardDiscount: 'calculateRewardDiscount',
    }),

    async onApplyRewards() {
      try {
        if (!this.rewardBalance || this.rewardBalance.currentBalance <= 0) {
          this.showAtmAlert({
            title: 'Saldo insuficiente',
            text: 'Você não possui saldo ecash disponível.',
            icon: 'warning',
          })
          return
        }

        // Verificar se o cliente já aceitou os termos
        if (!this.clientForm.isRewardProgramOptedIn) {
          this.$refs.rewardTermsModal.show()
          return
        }


        if (!this.clientForm.emailAccess) {
          this.showAtmAlert({
            title: this.$t('Cadastro incompleto'),
            text: 'Para resgatar as recompensas, baixe o app da echope e complete seu cadastro.',
          })
        } else {
          // Iniciar processo de validação com código de verificação
          this.ecashLoading = true
          this.$refs.codeVerificationModal.show(this.clientForm.id, this.getTotalSale)
        }
      } catch (error) {
        this.showAtmAlert({
          error,
          icon: 'error',
        })
        this.ecashLoading = false
      }
    },

    async applyRewardDiscount() {
      try {
        const discountAmount = await this.stCalculateRewardDiscount({
          customerId: this.clientForm.id,
          saleTotal: this.getTotalSale,
          priceTableId: this.salePriceTableId,
        })

        if (!this.clientForm.emailAccess) {
          this.showAtmAlert({
            title: this.$t('Cadastro incompleto'),
            text: 'Para resgatar as recompensas, baixe o app da echope e complete seu cadastro.',
          })
        } else if (discountAmount > 0) {

            await this.stApplyRewards(discountAmount)

        }
      } catch (error) {
        this.showAtmAlert({
          error,
          icon: 'error',
        })
      }
    },

    async onTermsAccepted() {
      try {
        this.ecashLoading = true

        // Persistir o aceite dos termos no backend
        await axiosInstance.put('/api/reward-accept-terms', {
          customerId: this.clientForm.id,
          termsVersion: this.rewardConfiguration.termsVersion,
        })

        // Atualizar o clientForm com o aceite dos termos via store
        await this.stSetRewardProgramOptedIn(true)

        // Aplicar o desconto
        await this.onApplyRewards()
      } catch (error) {
        this.showAtmAlert({
          error,
          icon: 'error',
          title: 'Erro ao aceitar termos',
        })
      } finally {
        this.ecashLoading = false
      }
    },

    onTermsRejected() {
      this.showAtmAlert({
        title: 'Termos não aceitos',
        text: 'Para usar o saldo ecash, você precisa aceitar os termos e condições do programa.',
        icon: 'info',
        timer: 3000,
      })
    },

    async onCodeVerified() {
      try {
        // Aplicar o desconto após validação bem-sucedida
        await this.applyRewardDiscount()
      } catch (error) {
        this.showAtmAlert({
          error,
          icon: 'error',
        })
      } finally {
        this.ecashLoading = false
      }
    },

    onCodeVerificationCancelled() {
      this.ecashLoading = false
    },

    async onRemoveRewards() {
      await this.stApplyRewards(0)
    },

    async onPayment() {
      try {
        this.paymentLoading = true
        const validationResult = await this.stValidateCartItems()
        if (!validationResult.isValid) {
          this.showAtmAlert({
            title: 'Há produtos sem estoque no carrinho',
            text: '',
            icon: 'warning',
          })

          return
        }

        this.stSetAtmScreen(atmScreenEnum.PAYMENT)
        this.onHide()
      } catch (error) {
        this.showAtmAlert({
          error,
          icon: 'error',
        })
      } finally {
        this.paymentLoading = false
      }
    },

    onHide() {
      this.stSetIsCartOpen(false)
    },

    async onAddSuggestion(suggestionItem) {
      try {
        this.addItemLoading = true
        await this.stAddItemFromAtm({
          amount: suggestionItem.quantity || 1,
          ean: suggestionItem.ean,
          skuId: suggestionItem.skuId,
          isKit: false,
          isSuggestion: true,
        })
      } catch (error) {
        this.showAtmAlert({
          error,
          icon: 'error',
          title: 'Erro ao adicionar sugestão',
        })
      } finally {
        this.addItemLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.cart-container {
  // padding: 5px;
  border-radius: 0.428rem;

  // width: 98vw;
  // scrollbar-width: none;

  // animation: scroll-shadow-inset linear;
  // animation-timeline: scroll(self inline);

  .cart-itens-container {
    display: flex;
    justify-content: flex-start;
    // gap: 5px;
  }
}

.cart-footer {
  display: flex;
  gap: 20px;
}

.ecash-section {
  .ecash-card {
    background: white;
    border: 2px solid #28a745;
    border-radius: 15px;
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.15);

    .ecash-logo-header {
      width: 100px;
      height: auto;
    }

    .ecash-logo {
      width: 60px;
      height: auto;
    }
  }
}
</style>
